export const FETCH_DOCUMENT_TYPE = 'pages/documentType/FETCH_DOCUMENT_TYPE';
export const FETCH_DOCUMENT_TYPE_META_DATA = 'pages/documentType/FETCH_DOCUMENT_TYPE_META_DATA';
